import * as React from "react";
import "../assets/vendors/style";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Form, message } from "antd";
import { useStore } from "react-redux";
import { storeNamePage } from "../appRedux/actions/Auth";
import { userStore } from "../appRedux/actions/index";
import { useHistory, useLocation } from "react-router-dom";
import Spinner from "reactstrap/lib/Spinner";
import { useCookies } from "react-cookie";
import { env } from "../env";
import { BUS_SITE_LOCAL, BUS_SITE_LOCAL_IP } from "../constants/StoreSetting";
import { checkIsWeb, postDataToApp } from "../appRedux/actions/MobAppFn";
import { PostAppTypes } from "../constants/MobAppConstants";

message.config({
  duration: 1,
  top: 24,
});

const { REACT_APP_BUS_SITE_APP } = env
const TS_APP_BASE_WEB_URL = `${REACT_APP_BUS_SITE_APP}`;
const TS_APP_BASE_LOCAL_URL = `${BUS_SITE_LOCAL}`;
const TS_APP_BASE_LOCAL_IP = `${BUS_SITE_LOCAL_IP}`;
const { TS_COOKIE_BASE_DOMAIN } = env;

const CheckLoginCredentials = () => {
  const [form] = Form.useForm();
  //const useEffect = useEffect();
  const store = useStore();
  const [cookies, setCookie] = useCookies(["storeName", "storeHash", "reqNo"]);
  // let storeName = localStorage.getItem("storeName");
  // let storeHash = localStorage.getItem("storeHash");

  // if (storeName != null) {
  //   form.setFieldsValue({ storeName: storeName });
  //   message.success("You already signed in to " + storeName);
  // }
  interface authState {
    auth: any;
  }
  interface commonState {
    commonData: any;
  }
  interface loaderStateInterface {
    commonConfigs: any;
  }
  const FormItem = Form.Item;
  const dispatch = useDispatch();
  const history = useHistory();
  // const [refererValue, setrefererValue] = React.useState(false);
  const selectAuth = (state: authState) => state.auth.storeVariable;
  const commonDataRedux = (state: commonState) => state && state.commonData ? state.commonData : false;
  const loaderRedux = (state: loaderStateInterface) => state.commonConfigs;

  const storeredux = useSelector(selectAuth);
  const commonRedux = useSelector(commonDataRedux);
  const loaderSelector = useSelector(loaderRedux);
  let cookie_StoreName = cookies.storeName;
  let cookie_StoreHash = cookies.storeHash;
  let cookie_reqNo = cookies.reqNo;
  useEffect(() => {
    if(checkIsWeb().exist){
      const baseURL = window.location.origin;
      var isCookieSet = cookie_StoreName && cookie_StoreHash ? true : false;
      var cookieStoreName =
        storeredux && storeredux.storeName
          ? storeredux.storeName
          : cookie_StoreName;
      var cookieStoreHash =
        storeredux && storeredux.storeHash
          ? storeredux.storeHash
          : cookie_StoreHash;
      var cookieReqNo =
          storeredux && storeredux.reqNo
            ? storeredux.reqNo
            : cookie_reqNo;
  
      if (TS_APP_BASE_LOCAL_URL != baseURL && baseURL != TS_APP_BASE_WEB_URL && TS_APP_BASE_LOCAL_IP != baseURL) {
        const url = window.location.href;
        let domainName = "";
        try {
          domainName = new URL(url).hostname.split(".")[0];
          if (!domainName) {
             window.location.href = TS_APP_BASE_WEB_URL + "/signin";
          } else {
            if (!cookieStoreName && !cookieStoreHash && !isCookieSet) {
              const storeObj = {
                storeName: domainName,
              };
              dispatch(userStore(storeObj, form, history));
            }
          }
        } catch (errorCatch) {
          // Handle errors when URL is not valid or cannot be parsed
          //message.error(`Error: ${errorCatch}`);
          
        }
       
      }
  
      //if(isReloadPage==null || isReloadPage=='' || isReloadPage == undefined)
      //{
  
      if (cookieStoreName && cookieStoreHash) {
        if (!isCookieSet) {
          setCookie("storeName", cookieStoreName, {
            domain: TS_COOKIE_BASE_DOMAIN,
            path: "/",
          });
          setCookie("storeHash", cookieStoreHash, {
            domain: TS_COOKIE_BASE_DOMAIN,
            path: "/",
          });
          setCookie("reqNo", cookieReqNo, {
            domain: TS_COOKIE_BASE_DOMAIN,
            path: "/",
          });
        }
        storeNamePage(cookieStoreName, cookieStoreHash);
      }
      //}
    }
  }, [
    storeredux != null && storeredux.storeName ? storeredux.storeName : ""
    ,commonRedux.loading,
  ]); // storeredux.storeName, commonRedux.loading

  return (
    <></>
  );
};

export default CheckLoginCredentials;
